import { RootState } from 'application/store';

export const requestSelector = (state: RootState) => state.request;
